import { render, staticRenderFns } from "./discussion.vue?vue&type=template&id=083dd2d8&scoped=true"
import script from "./discussion.vue?vue&type=script&lang=js"
export * from "./discussion.vue?vue&type=script&lang=js"
import style0 from "./discussion.vue?vue&type=style&index=0&id=083dd2d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083dd2d8",
  null
  
)

export default component.exports